module.exports = __webpack_public_path__ + "img/jiangsu_s.6decd4b.png";